export function parseDate(apiDate: string): Date {
    const [day, month, year] = apiDate.split("/").map(Number);
    return new Date(year, month - 1, day); // Month is 0-based in JS Date
}